import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import {
  ICardAccess,
  ICardCredentials,
} from 'src/app/user-management/user-management-interfaces';

@Component({
  selector: 'app-user-physical-credentials-list',
  templateUrl: './user-physical-credentials-list.component.html',
  styleUrls: ['./user-physical-credentials-list.component.scss'],
})
export class UserPhysicalCredentialsListComponent implements OnInit {
  @Output() credentials = new EventEmitter<ICardCredentials>();
  @Input() userCredentials: ICardCredentials[] = [];
  @Input() step?: number;
  @Output() stepChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  selectedCredentials?: ICardCredentials;
  sharedData?: ISharedData;
commonAccessControl : boolean =false
  constructor(private accountSettingService: AccountSettingsService,
    public stateManagementService: StateManagementService,
    private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;

  }

  viewCredentialDetails(
    cardId: string,
    cardName: string,
    badgeId: string,
    cardStatus: string,
    disable: boolean,
    cardAccess: ICardAccess
  ): void {
    this.selectedCredentials = {
      cardId,
      cardName,
      badgeId,
      cardStatus,
      disable,
      cardAccess,
    };
    this.getUserAccessOnRFID(cardId, badgeId);
    this.credentials.emit(this.selectedCredentials);
    this.stepChange.emit((this.step = 2));
  }

  /**
   * @description getUserAccessOnRFID function will call the getUserAccessOnRFID API
   * @returns void
   */
  getUserAccessOnRFID(cardId: string, badgeId: string): void {
    this.accountSettingService.getUserAccessOnRFID(cardId, badgeId).subscribe({
      next: (res: any) => {
        if (res) {
          const userAccessOnRFID = res.getUserAccessOnRFID;
          this.selectedCredentials!.cardAccess = userAccessOnRFID?.cardAccess;
          if(!this.commonAccessControl){
            const filteredTemporaryAccess = userAccessOnRFID?.cardAccess.temporaryAccess?.filter((access: { entityType: string; }) => access.entityType !== 'AccessPoint');
        const filteredOtherAccess = userAccessOnRFID?.cardAccess.otherAccess?.filter((access: { entityType: string; }) => access.entityType !== 'AccessPoint');
        this.selectedCredentials!.accessCount =
          (userAccessOnRFID?.cardAccess.homeAccess?.length || 0) +
          (filteredOtherAccess?.length || 0) +
          (filteredTemporaryAccess?.length || 0);

          } else{
            this.selectedCredentials!.accessCount =
            userAccessOnRFID?.cardAccess.homeAccess?.length +
            userAccessOnRFID?.cardAccess.otherAccess?.length +
            userAccessOnRFID?.cardAccess.temporaryAccess?.length;
          }
        }
      },
    });
  }
}
